import React from "react";
import {
  Avatar,
  ListItem,
  ListItemAvatar,
  ListItemText,
  makeStyles,
  Typography,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  avatarWrapper: {
    minWidth: 0,
  },
  avatar: {
    padding: 0,
    background: "transparent",
    color: "#21242c",
    width: "24px",
    height: "24px",
    marginRight: "8px",
  },
  avatarText: {
    fontSize: "20px",
    fontWeight: 600,
    display: "flex",
    gap: "16px",
    alignItems: "center",
    color: "#21242c",
    margin: 0,
    flex: 1,
    justifyContent: "space-between",
  },
  listItem: {
    padding: 0,
    flexWrap: "wrap",
  },
}));

const SectionTitle = (props) => {
  const { icon, label, rightSection } = props;
  const classes = useStyles();
  return (
    <ListItem className={classes.listItem}>
      <ListItemAvatar className={classes.avatarWrapper}>
        <Avatar className={classes.avatar}>{icon}</Avatar>
      </ListItemAvatar>
      <ListItemText>
        <p className={classes.avatarText}>
          <span>{label}</span>
          {rightSection && <span>{rightSection}</span>}
        </p>
      </ListItemText>
    </ListItem>
  );
};

export default SectionTitle;
